// src/pages/FicheFrais/components/CarpoolFields.jsx
import React from "react";
import Field from "../ui/Field";
import { FaUsers } from "react-icons/fa";

const countNames = (csv) =>
  String(csv || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean).length;

export default function CarpoolFields({ draft, setDraft }) {
  const show = draft?.moyen_transport === "voiture" && !!draft?.covoiturage;
  if (!show) return null;

  const role = String(draft?.covoiturage_role || "").trim();
  const withNames = String(draft?.covoiturage_avec || "");
  const suggestedCount = countNames(withNames);

  const showNb = role === "Conducteur";

  return (
    <div className="rounded-2xl ring-1 ring-slate-200 bg-white p-4">
      <div className="flex items-center gap-2 font-semibold text-slate-800">
        <FaUsers className="text-slate-500" />
        Informations covoiturage
      </div>

      <div className="mt-3 grid gap-4 md:grid-cols-2">
        <label className="block">
          <div className="text-sm font-semibold text-slate-700 mb-1">Rôle *</div>
          <select
            value={role}
            onChange={(e) => {
              const nextRole = e.target.value;
              setDraft((p) => ({
                ...p,
                covoiturage_role: nextRole,
                covoiturage_nb_passagers:
                  nextRole === "Passager" ? 0 : Number(p.covoiturage_nb_passagers ?? 0),
              }));
            }}
            className="w-full rounded-xl px-3 py-2 ring-1 ring-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
          >
            <option value="">— Sélectionner —</option>
            <option value="Conducteur">Conducteur</option>
            <option value="Passager">Passager</option>
          </select>
        </label>

        <Field
          label={role === "Passager" ? "Conducteur (nom) *" : "Passagers (noms séparés par une virgule) *"}
          value={withNames}
          onChange={(v) => setDraft((p) => ({ ...p, covoiturage_avec: v }))}
          placeholder={role === "Passager" ? "Ex : Jean Dupont" : "Ex : Jean Dupont, Marie Martin"}
        />

        {showNb ? (
          <label className="block md:col-span-2">
            <div className="text-sm font-semibold text-slate-700 mb-1">
              Nombre de passagers (hors conducteur) *
            </div>

            <div className="flex gap-2 items-center">
              <input
                type="number"
                min={0}
                step={1}
                value={Number(draft?.covoiturage_nb_passagers ?? 0)}
                onChange={(e) =>
                  setDraft((p) => ({
                    ...p,
                    covoiturage_nb_passagers: Math.max(0, Math.floor(Number(e.target.value || 0))),
                  }))
                }
                className="w-full rounded-xl px-3 py-2 ring-1 ring-slate-200 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />

              <button
                type="button"
                onClick={() =>
                  setDraft((p) => ({
                    ...p,
                    covoiturage_nb_passagers: Math.min(99, suggestedCount),
                  }))
                }
                className="shrink-0 rounded-xl px-3 py-2 ring-1 ring-slate-200 bg-slate-50 hover:bg-slate-100 text-sm"
              >
                Auto ({Math.min(99, suggestedCount)})
              </button>
            </div>

            <div className="text-xs text-slate-500 mt-2">
              Barème IK : 0 passager = 0.28 • 1 = 0.38 • 2 = 0.48 • 3+ = 0.58
            </div>
          </label>
        ) : null}
      </div>
    </div>
  );
}
